var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContainerWithMenu',[_c('div',{staticClass:"page-content"},[_c('h1',{staticClass:"h2 margin-0"},[_vm._v("Registro dei Corrispettivi")])])])}
var staticRenderFns = []

export { render, staticRenderFns }